
export default {
  name: 'owner-contract',
  props: {
    contractLang: {
      type: String,
      default: 'ja'
    }
  },
  data: function () {
    return {
      lang: this.contractLang === 'zh' ? 'zh' : 'ja',
      contractUrl: '',
      blobUrl: '',
      requestId: 0
    };
  },
  computed: {
    pdfSrc: function () {
      if (!this.contractUrl) return '';
      if (String(this.contractUrl).indexOf('blob:') === 0) return this.contractUrl;
      return this.url(this.contractUrl);
    }
  },
  watch: {
    contractLang: function (lang) {
      this.onLang(lang);
    }
  },
  created: function () {
    this.$eventBus.$on('owner-contract-lang', this.onLang);
    this.loadFile(this.lang);
  },
  beforeDestroy: function () {
    this.$eventBus.$off('owner-contract-lang', this.onLang);
    this.requestId += 1;
    this.revokeBlob();
  },
  methods: {
    onLang: function (lang) {
      var nextLang = lang === 'zh' ? 'zh' : 'ja';
      if (nextLang === this.lang) return;
      this.lang = nextLang;
      this.loadFile(nextLang);
    },
    goBack: function () {
      this.$router.push('/owner');
    },
    revokeBlob: function () {
      if (this.blobUrl) {
        window.URL.revokeObjectURL(this.blobUrl);
        this.blobUrl = '';
      }
    },
    loadFile: function (lang) {
      var t = this;
      var requestedLang = lang === 'zh' ? 'zh' : 'ja';
      var currentRequest = ++this.requestId;
      this.revokeBlob();
      this.contractUrl = '';
      axios.get('landlord/contract/file', {
        params: { lang: requestedLang },
        responseType: 'blob'
      }).then(function (res) {
        if (currentRequest !== t.requestId) return;
        var blob = res.data;
        var ctype = '';
        if (res.headers) {
          ctype = res.headers['content-type'] || res.headers['Content-Type'] || '';
        }
        if (!ctype && blob && blob.type) ctype = blob.type;
        if (ctype.indexOf('application/json') !== -1 || ctype.indexOf('text/') === 0) {
          t.revokeBlob();
          t.contractUrl = '';
          return;
        }
        if (ctype.indexOf('pdf') === -1) {
          t.revokeBlob();
          t.contractUrl = '';
          return;
        }
        t.revokeBlob();
        t.blobUrl = window.URL.createObjectURL(blob);
        t.contractUrl = t.blobUrl;
      }).catch(function () {
        if (currentRequest !== t.requestId) return;
        t.revokeBlob();
        t.contractUrl = '';
      });
    }
  }
};
